import React from 'react';

const Main = () => {
  return (
    <main className="main-content container">
      <section className="intro">
        <h2>Ozjackpotclaim – Your Gateway to Online Australian Lottery Excitement!</h2>
        <p>
          The Ozjackpotclaim Mega Jackpot is a unique number lottery that ensures a winner in every draw while providing an extraordinary jackpot opportunity!
          Unlike traditional lotteries, you don’t select numbers—each ticket comes with a distinct ID, and if your ticket is drawn, you win!
          Each draw gives you the chance to snag two grand prizes: a guaranteed $200,000 prize and the Mega Jackpot, which has now exceeded $5.6 million!
          To claim the Mega Jackpot, your ticket must be drawn for a second-chance prize.
        </p>
        <p>
          <strong>How It Works:</strong> With a limited ticket pool of up to 200,000 for each draw, your chances of winning are significantly enhanced.
          Purchase one or more tickets, and if your number is selected, you’re guaranteed a prize! Holding more tickets increases your odds.
          Draws occur regularly, and results can be checked online.
        </p>
        <p>Don’t miss out—opt for a QuickPick or play your preferred numbers today!</p>
        <small>*Please be aware that participation in public lotteries is limited to individuals aged 18 and over.</small><br />
        <small>**Maximum Division 1 prize pool of $5.4 million across 10 cash prize tiers.</small>
      </section>

      <section className="testimonials">
        {[
          {
            name: 'Mason Carter',
            text: 'I’ve always enjoyed participating in lotteries, but the Lucky Lotteries Mega Jackpot truly stands apart due to its enticing odds. Rather than selecting numbers, every ticket offers a straightforward opportunity to win. Although I haven’t won the jackpot yet, I’ve had some fantastic wins along the way, which keeps the thrill alive!',
          },
          {
            name: 'Grayson Parker',
            text: 'I really like that the Ozjackpotclaim Mega Jackpot has a limited ticket availability, as it enhances my chances of winning. I’ve experienced some fortunate moments with smaller prizes, which adds to the thrill! While the $200,000 top prize is a great motivation, it’s the enormous jackpot that everyone is after. It’s definitely one of my favorites among lotteries!',
          },
          {
            name: 'Sawyer James',
            text: 'I learned about the Ozjackpotclaim Mega Jackpot from a friend and thought I’d give it a try. What I appreciate the most is that there are guaranteed prizes in every draw. Each time I buy a ticket, I can’t help but think, ‘What if my number is the winning one?’ I’m eagerly awaiting the day that fortune smiles upon me!',
          }
        ].map((item, idx) => (
          <div className="testimonial-box" key={idx}>
            <div className="stars"><img src="../images/star.svg" alt="" />
              <img src="../images/star.svg" alt="" />
              <img src="../images/star.svg" alt="" />
              <img src="../images/star.svg" alt="" />
              <img src="../images/star.svg" alt="" />

            </div>
            <h4>{item.name}</h4>
            <p>{item.text}</p>
          </div>
        ))}
      </section>
    </main>
  );
};

export default Main;
